/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Card, Col, Form, Tabs, TabsProps } from "antd";
import { useForm } from "react-hook-form";

import { useEffect, useState } from "react";

import { useAppDispatch } from "../../../../../config/hooks";
import GeneralTab from "./Tabs/general";
import LaborTab from "./Tabs/labor";
import { createService, uploadUserImage } from "../../ducks/services";
import SuccessMessage from "../../../../../atoms/Toasts/SuccessMessage";
import { AxiosError, AxiosResponse } from "axios";
import ErrorMessage from "../../../../../atoms/Toasts/ErrorMessage";
import { useNavigate } from "react-router-dom";
import { RcFile } from "antd/es/upload";
import { getServiceFormData } from "../../ducks/actions";

interface FormValues {
  name: string;
  description: string;
  frequency: string;
  quantity_unit: string;
  take_off: string;
  subcontractors: string;
  category_ids: string[];
  production_rate: number;
  materials: { manager: string; use_rate: number; unit_order: string }[];
  equipment: string[];
}

interface PropsType {
  setCurrent?: (current: number) => void;
  setLoading: (loading: boolean) => void;
  companyId: string;
  serviceLineId: string;
  type: null | string;
  parentId?: string;
  frequencyTypeData?: {
    frequency: string;
  };
}
interface materialDropDownType {
  label: string;
  options: { value: string; label: string; color?: string; type: string }[];
}
export default function AddServiceStep2(props: PropsType) {
  const {
    setCurrent,
    setLoading,
    companyId,
    serviceLineId,
    type,
    parentId,
    frequencyTypeData,
  } = props;
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [activeTab, setActiveTab] = useState("1");
  const [serviceType, setServiceType] = useState("in_house");
  const [frequencyType, setFrequencyType] = useState("one_time");
  const [takeOff, isTakeOff] = useState(false);
  const [takeOffType, setTakeOffType] = useState("...");
  const [checklistFile, setChecklistFile] = useState<File | null>(null);
  const [addEquipment, setAddEquipment] = useState(false);
  const [unitHour, setUnitHour] = useState(true);
  const [tickIcon, showTickIcon] = useState(false);
  const [combineDropDown, setCombineDropDown] = useState<
    materialDropDownType[]
  >([]);

  const {
    control,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm<FormValues>();

  const onSubmit = (val: FormValues) => {
    if (activeTab === "1") {
      const nameValue = val?.name;
      const unitValue = val?.quantity_unit;
      const takeOffValue = val?.take_off;

      if (
        type === "simple" &&
        nameValue?.length > 0 &&
        (unitValue?.length > 0 || takeOffValue?.length > 0)
      ) {
        showTickIcon(true);
        setActiveTab("2");
      } else if (type !== "simple" && nameValue?.length > 0) {
        showTickIcon(true);
        setActiveTab("2");
      } else {
        showTickIcon(false);
      }
      return;
    }
    setLoading(true);

    const dummyArray: any[] = [];

    if (val?.materials?.length > 0) {
      val?.materials?.map((e: { manager: string }) => {
        combineDropDown?.forEach((resp) => {
          const filteredValue = resp?.options?.find(
            (opt) => opt?.value === e?.manager
          );
          if (filteredValue) {
            dummyArray.push(filteredValue);
          }
          return filteredValue;
        });

        return true;
      });
    }

    const materialsPayload = dummyArray?.map((item) => {
      // Create the base object for the payload item
      const payloadItem = {
        material_type: item.type, // Use the 'type' property from your input item
        use_rate:
          val?.materials?.find((e) => e?.manager === item?.value)?.use_rate ??
          0, // Get use_rate from the input item
        unit_order:
          val?.materials?.find((e) => e?.manager === item?.value)?.unit_order ??
          "material_unit_per_measurement_unit", // Get unit_order from the input item
        material_category_id: undefined,
        material_id: undefined,
      };

      // Add the appropriate ID based on the item's type
      if (item.type === "category") {
        payloadItem.material_category_id = item.value; // Use the item's value as the category ID
      } else if (item.type === "material") {
        payloadItem.material_id = item.value; // Use the item's value as the material ID
      }

      // Return the transformed object for this item
      return payloadItem;
    });

    const payload = {
      name: val?.name,
      service_line_id: serviceLineId,
      company_id: companyId,
      parent_id: parentId ?? undefined,
      type: type,
      description: val?.description,
      service_provision_type: serviceType,
      frequency:
        frequencyType === "one_time"
          ? "one_time"
          : type === "subservice"
          ? "recurring"
          : val?.frequency,
      takeoff_id: takeOff ? val?.take_off : undefined,
      unit_id: takeOff ? undefined : val?.quantity_unit,
      production_rate:
        serviceType === "in_house" ? val?.production_rate : undefined,
      production_rate_type: unitHour ? "unit_per_hour" : "hour_per_unit",
      category_ids:
        val?.category_ids?.length > 0 ? val?.category_ids : undefined,
      materials: serviceType === "in_house" ? materialsPayload : undefined,
      equipments: serviceType === "in_house" ? val?.equipment : undefined,
    };

    createService(payload)
      .then((res: AxiosResponse) => {
        if (checklistFile && res && res?.data?.id) {
          uploadUserImage({
            owner_id: res?.data?.id,
            image: checklistFile as File | RcFile,
            image_type: "service_image",
          })
            .then(() => {
              setLoading(false);
              navigate(
                `/company-settings/service-lines/${serviceLineId}/${companyId}`
              );
              SuccessMessage("Service created");
            })
            .catch((e: unknown) => {
              if (e instanceof AxiosError) {
                setLoading(false);
                ErrorMessage(
                  e?.response?.data?.error?.message ?? "Something went wrong"
                );
              } else {
                setLoading(false);
                ErrorMessage("Something went wrong");
              }
            });
        } else {
          setLoading(false);
          navigate(
            `/company-settings/service-lines/${serviceLineId}/${companyId}`
          );
          SuccessMessage("Service created");
        }
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };

  const onChange = (key: string) => {
    setActiveTab(key);
  };

  const nameValue = watch("name");
  const unitValue = watch("quantity_unit");
  const takeOffValue = watch("take_off");

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "General details",
      children: (
        <GeneralTab
          control={control}
          errors={errors}
          setLoading={setLoading}
          serviceType={serviceType}
          setValue={setValue}
          frequencyType={frequencyType}
          takeOff={takeOff}
          type={type}
          isTakeOff={isTakeOff}
          setServiceType={setServiceType}
          setFrequencyType={setFrequencyType}
          checklistFile={checklistFile}
          setChecklistFile={setChecklistFile}
          setTakeOffType={setTakeOffType}
          frequencyTypeData={frequencyTypeData}
        />
      ),
    },
    {
      key: "2",
      label:
        type === "simple"
          ? serviceType === "in_house"
            ? "Labor, Materials, Equipment"
            : "Subcontractors"
          : "Subservice categories",
      disabled: !nameValue || (!unitValue && !takeOffValue),
      children: (
        <LaborTab
          control={control}
          errors={errors}
          type={type}
          setLoading={setLoading}
          serviceType={serviceType}
          companyId={companyId}
          combineDropDown={combineDropDown}
          addEquipment={addEquipment}
          setCombineDropDown={setCombineDropDown}
          setAddEquipment={setAddEquipment}
          takeOffType={takeOffType}
          watch={watch}
          unitHour={unitHour}
          setUnitHour={setUnitHour}
          setValue={setValue}
        />
      ),
    },
  ];

  useEffect(() => {
    if (companyId) {
      dispatch(getServiceFormData(companyId));
    }
  }, [companyId, dispatch]);

  useEffect(() => {
    if (frequencyTypeData?.frequency) {
      setFrequencyType(frequencyTypeData?.frequency);
    }
  }, [frequencyTypeData]);

  return (
    <Form layout="vertical" onFinish={handleSubmit(onSubmit)}>
      <Col style={{ width: "672px", paddingBottom: 85 }}>
        <div className="title">
          <h2 style={{ marginBottom: "4px" }}>
            Create {parentId ? "subservice" : "service"}{" "}
          </h2>
          <p style={{ fontSize: "16px" }}>
            A service becomes a work order, which your team schedules and
            completes.
          </p>
        </div>

        <div className="service_tabs">
          <Tabs
            activeKey={activeTab}
            items={items}
            onChange={onChange}
            className={tickIcon ? "tabsParent showTickIcon" : "tabsParent"}
          />
          {/* <div className="service_tabs_item active">General details</div>
          <div className="service_tabs_item">Labor, Materials, Equipment</div> */}
        </div>
      </Col>
      <div className="fixed_btm_card">
        <Card>
          <div className="centered">
            <Button
              htmlType="button"
              className="outlined-btn"
              onClick={() =>
                parentId
                  ? navigate(
                      `/company-settings/service-lines/${serviceLineId}/${companyId}`
                    )
                  : activeTab === "2"
                  ? setActiveTab("1")
                  : setCurrent && setCurrent(0)
              }
            >
              Back
            </Button>
            <div style={{ display: "flex", gap: "16px" }}>
              <Button
                htmlType="submit"
                type="primary"
                className="mint-btn"
                // onClick={() => setCurrent && setCurrent(1)}
              >
                {parentId
                  ? "Create subservice"
                  : activeTab === "2"
                  ? "Create service"
                  : "continue"}
              </Button>
            </div>
          </div>
        </Card>
      </div>
    </Form>
  );
}
